import { ToiletIcon } from './ToiletIcon';

/**
 * author: Augustin Ursu
 * id 5A1815F9-FC9E-4420-B723-AF4B324262A4
 * name toilet
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/toilet.svg
 * tags
 * - Home Automation 
 */
export const LavatoryIcon = ToiletIcon;
export default LavatoryIcon